export default __webpack_public_path__ + "static/media/__Kuvempu.43525856.jpg";